export enum WidgetSessionPerformanceEnum {
    CUSTOMERS_WITH_EVOLUTION = 'CUSTOMERS_WITH_EVOLUTION',
    TREATMENTS_CONCLUDED = 'TREATMENTS_CONCLUDED',
}
